export default __webpack_public_path__ + "static/media/badge_app_flare.705b2a5d.svg";